<template>
  <v-container fluid>
    <v-row no-gutters>
      <v-col cols="12" md="5" style="overflow-y: auto !important;width: 100%;height: 100vh;" class="ml-auto mr-auto d-flex align-center justify-center">
        <v-row no-gutters class="align-start">
          <ForgetPasswordForm></ForgetPasswordForm>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script type="text/javascript">
  import ForgetPasswordForm from "../components/ForgetPasswordForm/ForgetPasswordForm";

  export default {
    name: "PasswordForgetUser",
    components: {
      ForgetPasswordForm
    },
    mounted() {
      this.updateLanguage(this.getCurrentLanguage);
    }
  }
</script>